









































































































































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapGetters, mapActions } from 'vuex';
import { AuthV1ProfilePartialUpdateRequest, Profile, ProfileGenderEnum } from '@/requests/mainApi';
import UiButton from '@/components/ui/UiButton.vue';
import UiInput from '@/components/ui/UiInput.vue';
import UiLabel from '@/components/ui/UiLabel.vue';
import UiSelect from '@/components/ui/UiSelect.vue';
import UiDatePickerInline from '@/components/ui/UiDatePickerInline/UiDatePickerInline.vue';
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';
import { masks } from '@/utils/plugins/inputMask';
import { deepClone } from '@/utils/helpers/helpFunctions';
import { IProfileStatus } from '@/store/interfaces';
import { mainSiteLink } from '@/utils/plugins/links';

interface IProfileGender {
  label: string;
  value: ProfileGenderEnum;
}

interface Data {
  userModel: Profile;
  viewErrors: boolean;
  genders: IProfileGender[];
  reportLink: string;
  timeToOpenPage: number;
}

interface Methods {
  analyticsSend: () => void;
  updateUserData: (payload: AuthV1ProfilePartialUpdateRequest) => Promise<boolean>;
}

interface Computed {
  lastNameErrorView: boolean;
  firstNameErrorView: boolean;
  birthdayErrorView: boolean;
  maleErrorView: boolean;
  emailErrorView: boolean;
  snilsErrorView: boolean;
  innErrorView: boolean;
  profileIsCompleted: boolean;
  validate: boolean;
  userData: Profile;
  profileStatus: IProfileStatus;
}

interface Props {}

export default Vue.extend({
  name: 'ProfileEdit',
  components: {
    UiButton,
    UiInput,
    UiLabel,
    UiSelect,
    UiDatePickerInline,
  },
  mixins: [iconsMixin],
  data() {
    return {
      masks,
      userModel: {},
      viewErrors: false,
      genders: [
        {
          value: ProfileGenderEnum['Male'],
          label: 'Мужской',
        },
        {
          value: ProfileGenderEnum['Female'],
          label: 'Женский',
        },
      ],
      reportLink: `${mainSiteLink}?openform=contact`,
      timeToOpenPage: new Date().getTime(),
    };
  },
  computed: {
    lastNameErrorView() {
      return this.viewErrors && !this.userModel.lastName;
    },
    firstNameErrorView() {
      return this.viewErrors && !this.userModel.firstName;
    },
    birthdayErrorView() {
      return this.viewErrors && !this.userModel.birthday;
    },
    maleErrorView() {
      return this.viewErrors && !this.userModel.gender;
    },
    emailErrorView() {
      return this.viewErrors && Boolean(this.userModel.email) && !/\S+@\S+\.\S+/.test(this.userModel.email);
    },
    snilsErrorView() {
      return this.viewErrors && this.userModel.snils && this.userModel.snils.length > 0 && this.userModel.snils.length !== 11;
    },
    innErrorView() {
      return this.viewErrors && this.userModel.inn && this.userModel.inn.length > 0 && this.userModel.inn.length !== 12;
    },
    validate() {
      return (
        !this.lastNameErrorView &&
        !this.firstNameErrorView &&
        !this.birthdayErrorView &&
        !this.maleErrorView &&
        !this.emailErrorView &&
        !this.snilsErrorView &&
        !this.innErrorView
      );
    },
    profileStatus() {
      if (!this.profileIsCompleted) {
        return 'profileIsEmpty';
      }

      if (this.userData.docsIsUploaded && !this.userData.isVerified) {
        return 'docsIsUploaded';
      }

      if (this.userData.isVerified) {
        return 'isVerified';
      }

      return 'docsIsNotUploaded';
    },
    ...mapGetters(['userData', 'profileIsCompleted']),
  },
  watch: {
    userData: {
      handler(val) {
        this.userModel = deepClone(val);
        if (this.userModel.gender === ProfileGenderEnum['Unknown']) this.userModel.gender = undefined;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async send() {
      this.viewErrors = true;
      if (!this.validate) return;
      if (this.profileStatus === 'isVerified') return;
      const result: boolean = await this.updateUserData({
        data: this.userModel,
      });
      if (!result) return;
      this.$analytics.logEvent('finish_registration', {
        screen: 'profile',
        time: Math.round((new Date().getTime() - this.timeToOpenPage) / 1000),
        first_name: this.userModel.firstName === this.userData.firstName,
        last_name: this.userModel.lastName === this.userData.lastName,
        patronymic_name: this.userModel.patronymicName === this.userData.patronymicName,
        sex: this.userModel.gender,
        date_of_birth: this.userModel.birthday ? new Date().toLocaleDateString('ru') : '',
        email: this.userModel.email === this.userData.email,
      });
    },
    analyticsSend() {
      this.$analytics.logEvent('get_help', {
        screen: this.$route.meta.analyticsName,
      });
    },
    computeTranslate(position: string) {
      return this.$t(`app.profileEdit.${position}.${this.profileStatus}`);
    },
    ...mapActions(['updateUserData']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
